import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight, Building2 } from 'lucide-react';
interface ProjectCardProps {
  title: string;
  client: string;
  value: string;
  image: string;
  index: number;
  onClick?: () => void;
}
export function ProjectCard({
  title,
  client,
  value,
  image,
  index,
  onClick
}: ProjectCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.6,
    delay: index * 0.1
  }} onClick={onClick} className="group cursor-pointer relative overflow-hidden bg-white border border-border hover:border-stone/30 transition-all duration-300" data-id="element-230">
      {/* Image Container */}
      <div className="relative h-80 overflow-hidden bg-cream" data-id="element-231">
        <motion.img src={image} alt={title} className="w-full h-full object-cover" whileHover={{
        scale: 1.05
      }} transition={{
        duration: 0.6,
        ease: [0.16, 1, 0.3, 1]
      }} data-id="element-232" />

        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-charcoal/90 via-charcoal/40 to-transparent opacity-80 group-hover:opacity-90 transition-opacity" data-id="element-233" />

        {/* View Icon */}
        <div className="absolute top-6 right-6 w-10 h-10 bg-white text-charcoal flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-234">
          <ArrowUpRight size={20} strokeWidth={2} data-id="element-235" />
        </div>
      </div>

      {/* Content */}
      <div className="absolute bottom-0 left-0 right-0 p-8 text-white" data-id="element-236">
        <h3 className="font-heading font-semibold text-2xl mb-4 leading-tight" data-id="element-237">
          {title}
        </h3>

        <div className="flex items-center gap-6 text-sm" data-id="element-238">
          <div className="flex items-center gap-2" data-id="element-239">
            <Building2 size={16} className="text-gold" strokeWidth={2} data-id="element-240" />
            <span className="text-white/80" data-id="element-241">{client}</span>
          </div>
          <div className="text-gold font-semibold" data-id="element-242">{value}</div>
        </div>
      </div>
    </motion.div>;
}